import { render, staticRenderFns } from "./buttons-task-window.vue?vue&type=template&id=d763f42a&"
import script from "./buttons-task-window.vue?vue&type=script&lang=js&"
export * from "./buttons-task-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports